import React from 'react';

interface Props {
  mois: number;
  annee: number;
  onChange: (mois: number, annee: number) => void;
}

const MOIS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

export function PeriodeSelector({ mois, annee, onChange }: Props) {
  const anneeMin = new Date().getFullYear() - 3;
  const annees = Array.from({ length: 6 }, (_, i) => anneeMin + i);

  return (
    <div className="flex gap-2 items-center">
      <select
        value={mois}
        onChange={e => onChange(Number(e.target.value), annee)}
        className="border border-border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {MOIS.map((m, i) => (
          <option key={i + 1} value={i + 1}>{m}</option>
        ))}
      </select>
      <select
        value={annee}
        onChange={e => onChange(mois, Number(e.target.value))}
        className="border border-border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {annees.map(a => <option key={a} value={a}>{a}</option>)}
      </select>
    </div>
  );
}
